import styled from 'styled-components'

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => theme.bg1};
  border-radius: 16px;
  padding: 6px;
  width: 100%;
  cursor: pointer;
  position: relative;
`

export const ToggleOption = styled.div<{ active: boolean }>`
  flex: 1;
  text-align: center;
  padding: 10px 12px;
  font-size: 14px;
  font-weight: ${({ active }) => (active ? '600' : '400')};
  color: ${({ theme, active }) => (active ? theme.text5 : theme.text4)};
  background: ${({ theme, active }) => (active ? theme.primary1 : 'transparent')};
  border-radius: 12px;
  transition: all 0.2s ease-in-out;

  &:hover {
    color: ${({ theme, active }) => (active ? theme.text5 : theme.text3)};
  }
`
